import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { shortDate } from "@/lib/format";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Check, Pencil, X } from "lucide-react";

// Data di arrivo di un ordine gi\u00e0 arrivato, modificabile
export const ArrivalDate = ({ o }) => {
  const qc = useQueryClient();
  const [edit, setEdit] = useState(null);
  const today = new Date().toISOString().slice(0, 10);
  const save = useMutation({
    mutationFn: async (d) => (await api.patch(`/materials/orders/${o.id}/received-date`, { received_date: d })).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["material-orders"] }); setEdit(null); toast.success("Data di arrivo aggiornata"); },
    onError: (e) => toast.error(e.response?.data?.detail || "Data non salvata"),
  });
  if (edit !== null) {
    return (
      <span className="flex items-center gap-1">
        <Input type="date" autoFocus value={edit} min={o.order_date} max={today} onChange={(e) => setEdit(e.target.value)} className="h-7 w-36 text-xs" data-testid={`po-arrival-input-${o.id}`} />
        <Button size="icon" className="h-7 w-7" onClick={() => edit && save.mutate(edit)} disabled={save.isPending} data-testid={`po-arrival-save-${o.id}`}><Check className="h-3.5 w-3.5" /></Button>
        <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => setEdit(null)}><X className="h-3.5 w-3.5" /></Button>
      </span>
    );
  }
  return (
    <button type="button" onClick={() => setEdit(o.received_date)} title="Modifica la data di arrivo" className="group inline-flex items-center gap-1 hover:text-primary" data-testid={`po-arrival-${o.id}`}>
      {shortDate(o.received_date)}<Pencil className="h-3 w-3 opacity-50 group-hover:opacity-100" />
    </button>
  );
};
